import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Marcelo Andrade",
    initials: "MA",
    city: "Belém · PA",
    service: "Pane no motor",
    stars: 5,
    text:
      "Fiquei parado na BR-316 de madrugada e em 20 minutos o guincho chegou. Educados, rápidos e o preço foi exatamente o combinado no WhatsApp. Recomendo demais.",
  },
  {
    name: "Juliana Reis",
    initials: "JR",
    city: "Ananindeua · PA",
    service: "Reboque de moto",
    stars: 5,
    text:
      "Minha CB caiu perto de casa e chamei a Gorillas. Amarraram tudo com cinta profissional, sem risco de arranhão. Levaram até a oficina do meu mecânico. Nota mil.",
  },
  {
    name: "Rodrigo Machado",
    initials: "RM",
    city: "Marituba · PA",
    service: "Transporte EcoSport",
    stars: 5,
    text:
      "Precisei transferir meu carro da casa da minha mãe até uma oficina em Castanhal. Chegaram no horário combinado, cuidado com o veículo e pagamento no Pix na hora.",
  },
  {
    name: "Camila Duarte",
    initials: "CD",
    city: "Belém · PA",
    service: "Acidente urbano",
    stars: 5,
    text:
      "Bati o carro à noite e estava nervosa. O motorista foi calmo, me ajudou com a documentação no local e removeu o veículo com segurança. Salvaram meu dia.",
  },
];

export default function Reviews() {
  return (
    <section
      id="avaliacoes"
      data-testid="reviews-section"
      className="relative bg-brand-black py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        {/* Header */}
        <div className="grid grid-cols-12 gap-6 border-b border-chrome/15 pb-10">
          <div className="col-span-12 flex items-center gap-4 sm:col-span-4">
            <span className="font-mono text-xs tracking-[0.3em] text-brand-yellow">
              [ SEÇÃO 03 · AVALIAÇÕES ]
            </span>
            <span className="h-px flex-1 bg-chrome/20" />
          </div>
          <div className="col-span-12 sm:col-span-8">
            <h2
              data-testid="reviews-h2"
              className="font-display text-5xl uppercase leading-[0.9] tracking-tight text-white sm:text-7xl"
            >
              Quem chamou, <br />
              <span className="text-brand-yellow">recomenda.</span>
            </h2>
            <div className="mt-6 flex items-center gap-4">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 fill-brand-yellow text-brand-yellow"
                  />
                ))}
              </div>
              <span className="font-mono text-xs tracking-[0.25em] text-neutral-400">
                5.0 · CLIENTES REAIS
              </span>
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden border border-chrome/15 bg-chrome/15 sm:grid-cols-2">
          {REVIEWS.map((r, i) => (
            <motion.article
              key={r.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.7,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="group relative flex flex-col justify-between bg-brand-black p-7 transition-colors hover:bg-neutral-950 sm:p-10"
              data-testid={`review-${i}`}
            >
              <div>
                <div className="flex items-center justify-between">
                  <div className="flex gap-1">
                    {[...Array(r.stars)].map((_, s) => (
                      <Star
                        key={s}
                        className="h-4 w-4 fill-brand-yellow text-brand-yellow"
                      />
                    ))}
                  </div>
                  <Quote
                    className="h-8 w-8 text-brand-yellow/25 transition-colors group-hover:text-brand-yellow/50"
                    strokeWidth={1.5}
                  />
                </div>
                <p className="mt-6 font-body text-lg leading-relaxed text-neutral-200 sm:text-xl">
                  &ldquo;{r.text}&rdquo;
                </p>
              </div>

              <div className="mt-8 flex items-center justify-between border-t border-chrome/15 pt-6">
                <div className="flex items-center gap-3">
                  <div className="flex h-11 w-11 items-center justify-center bg-brand-yellow font-display text-base tracking-tight text-black">
                    {r.initials}
                  </div>
                  <div className="flex flex-col leading-tight">
                    <span className="font-display text-lg uppercase tracking-tight text-white">
                      {r.name}
                    </span>
                    <span className="font-mono text-[10px] tracking-[0.28em] text-neutral-500">
                      {r.city}
                    </span>
                  </div>
                </div>
                <span className="hidden font-mono text-[10px] tracking-[0.28em] text-brand-yellow sm:inline">
                  {r.service}
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
